import { MedicalLeavePuePayer } from '@dreryk/egabinet-ezla-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';

export type PayerNameFieldProps = Pick<
   FormContextValues<{
      payers: MedicalLeavePuePayer[] | null;
   }>,
   'register'
>;

export const PayerNameField = (props: PayerNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('payers.0.name', {
            maxLength: 100,
         })}
         label={commonTranslationKeys.payerName}
         testId={'payerName'}
      />
   );
};
